<div class="h-screen flex flex-col">
  @if (showHeader()) {
    <app-header />
  }
  <router-outlet />
</div>
